module.exports = __webpack_public_path__ + "images/noun_Arrow_6300888c5a10526861cd03301cb7b50883c24e.svg";